import { GET_WALLET_LIST, GET_WALLET_LIST_ERROR, GET_WALLET_LIST_REQUEST, UPDATE_WALLET_LIST_DATA, REMOVE_WALLET_LIST_DATA } from "../ActionTypes/ActionTypes.js";

const initialState = {
    walletListLoading: false,
    walletListData: null,
    walletListError: null,
    walletListStatus: null,
    isModified: false,
    isFirstLoad: true,


};

const walletListReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_WALLET_LIST_REQUEST:
            return { ...state, walletListLoading: state.isFirstLoad };
        case GET_WALLET_LIST:
            return {
                walletListLoading: false, walletListData: action.payload, walletListError: null, walletListStatus: true,

                isFirstLoad: false,
            };

        case GET_WALLET_LIST_ERROR:
            return { walletListLoading: false, walletListData: null, walletListError: action?.payload, walletListStatus: false, isFirstLoad: false, };
        case UPDATE_WALLET_LIST_DATA:
            return {
                ...state,
                walletListData: {
                    ...state.walletListData,
                    result: {
                        ...state.walletListData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_WALLET_LIST_DATA:
            return { ...state, walletListData: null, walletListError: null, isModified: false, walletListStatus: null, isFirstLoad: true, walletListLoading: false }
        default:
            return state;
    }
};

export default walletListReducer;